import { z } from 'zod';

// ─── Invite Event Payloads ──────────────────────────────────────────
// Invite creation/regeneration is handled synchronously by the API route
// (the DB write happens inline). These events are fire-and-forget hints
// for observers — currently only the audit service consumes them.

export const InviteCreatedPayload = z.object({
    inviteId:    z.string().min(1),
    email:       z.string().email(),
    accessId:    z.string().min(1),
    tenantId:    z.string().min(1),
    expiresAt:   z.string().datetime(),
    sendEmail:   z.boolean().default(true),
    bulk:        z.boolean().default(false),
});

export type InviteCreatedPayload = z.infer<typeof InviteCreatedPayload>;

export const InviteRegeneratedPayload = z.object({
    inviteId:    z.string().min(1),
    email:       z.string().email(),
    accessId:    z.string().min(1),
    tenantId:    z.string().min(1),
    expiresAt:   z.string().datetime(),
});

export type InviteRegeneratedPayload = z.infer<typeof InviteRegeneratedPayload>;

export const InviteResentPayload = z.object({
    inviteId:    z.string().min(1),
    email:       z.string().email(),
    accessId:    z.string().min(1),
    tenantId:    z.string().min(1),
    expiresAt:   z.string().datetime(),
});

export type InviteResentPayload = z.infer<typeof InviteResentPayload>;

export const InviteRevokedPayload = z.object({
    inviteId:    z.string().min(1),
    email:       z.string().email(),
    accessId:    z.string().min(1),
    tenantId:    z.string().min(1),
});

export type InviteRevokedPayload = z.infer<typeof InviteRevokedPayload>;
